import { currentEnv } from '@/env/vars'
import { POST } from '@/utils/fetch'

export const uploadFilesToAgent = async (formData: FormData) => {
    return await POST(`${currentEnv.uploadToAgentUrl}/file-manager/fm/v1/upload`, formData, true).then((response) => {
        return response
    })
}

export const getFileManagerURL = async (fileID: string) => {
    return await POST(`${currentEnv.uploadToAgentUrl}/file-manager/fm/v1/sas`, {
        gigiFileManagerId: fileID,
        daysExpiration: 8,
    }).then((response) => {
        return response
    })
}
